import React, { useState } from "react";
import { Image, Container } from "semantic-ui-react";
import Carousel from "../../../components/Carousel";
import * as Icon from "react-feather";
import Modal from "../../../components/Modal";
const SliderSection: React.FC<{ channelType: string }> = ({ channelType }) => {
  const [showvideo, setShowVideo] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const SLIDE_ITEMS = [
    {
      url: `${process.env.PUBLIC_URL}/images/slide-3.png`,
      video: "",
      key: "slide-2",
    },
    {
      url: `${process.env.PUBLIC_URL}/images/slide-2.png`,
      video: "",
      key: "slide-3",
    },
    {
      url: `${process.env.PUBLIC_URL}/images/slide-1.png`,
      video: "https://www.youtube.com/embed/z1-JRfjcsvI",
      key: "slide-1",
    },
    {
      url: `${process.env.PUBLIC_URL}/images/slide-4.png`,
      video: "",
      key: "slide-4",
    },
    {
      url: `${process.env.PUBLIC_URL}/images/slide-5.png`,
      video: "",
      key: "slide-5",
    },
  ];
  const onShowVideo = (url: string) => {
    setShowVideo(true);
    setVideoUrl(url);
  };
  return (
    <>
      <div className="section section-slider">
        <div className="section-inner">
          <div className="section-header">
            <Image
              src={`${process.env.PUBLIC_URL}/images/${channelType}/thong-tin.png`}
              alt="Galaxy play logo"
              className="logo"
            />
          </div>
          <div className="section-body">
            <Container className="container-carousel">
              <Carousel>
                {SLIDE_ITEMS.map((item) => (
                  <div className="carousel-item" key={item.key}>
                    <Image src={item.url} key={item.key} alt={item.key} />
                    {(item.video && (
                      <div
                        className="play-btn"
                        onClick={() => onShowVideo(item.video)}
                      >
                        <Icon.PlayCircle size={60} style={{ color: "#fff" }} />
                      </div>
                    )) || <></>}
                  </div>
                ))}
              </Carousel>
            </Container>
            <Container>
              <div className="intro-text">
                <p className="white center">
                  Nhà bà Nữ là một bộ phim điện ảnh chính kịch, sau một tháng
                  công chiếu đã thu về gần 500 tỷ đồng trở thành phim Việt ăn
                  khách nhất lịch sử. Phim xoay quanh gia đình của bà Nữ - người
                  làm nghề bán bánh canh. Truyện phim khắc họa mối quan hệ phức
                  tạp, đa chiều xảy ra với các thành viên trong gia đình. Câu
                  tagline (thông điệp) chính "Mỗi gia đình đều có những bí mật"
                  chứa nhiều ẩn ý về nội dung bộ phim muốn gửi gắm.
                </p>
              </div>
            </Container>
          </div>
        </div>
      </div>
      <Modal
        className="modal-video"
        isShowFooter={false}
        isShowHeader={false}
        onClose={() => setShowVideo(false)}
        isShowCloseIcon={true}
        width={900}
        isOpen={showvideo}
        render={() => (
          <div className="video-container">
            <iframe
              src={videoUrl}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        )}
      />
    </>
  );
};
export default SliderSection;
